import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

const integrations = [
  { name: 'Google Drive', desc: 'Sync and link documents from Google Drive.', link: 'https://docs.equa.cc' },
  { name: 'Microsoft', desc: 'Azure AD and OneDrive integration.', link: 'https://docs.equa.cc' },
  { name: 'API', desc: 'Build on top of our API.', link: 'https://api.equa.cc' },
]

export const IntegrationsPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Integrations</PageTitle>
        <PageSubtitle>Connect your tools and workflows.</PageSubtitle>
      </MarketingSection>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {integrations.map((i) => (
          <div key={i.name} style={{ padding: '1rem', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8 }}>
            <h3 style={{ marginBottom: '0.25rem' }}>{i.name}</h3>
            <p style={{ margin: 0, fontSize: '0.875rem', opacity: 0.9 }}>{i.desc}</p>
            <a href={i.link} target="_blank" rel="noopener noreferrer" style={{ color: '#3292C0', fontSize: '0.875rem', marginTop: '0.5rem', display: 'inline-block' }}>Learn more</a>
          </div>
        ))}
      </div>
    </MarketingPageContainer>
  </MarketingLayout>
)
